import { graphql } from 'react-relay';

export const sectionPageFragment = graphql`
  fragment SectionPage_page on SectionPage {
    breadcrumbs {
      ...Breadcrumb_data
    }
    sections {
      __typename
      anchorName
      navigationTitle
      titleImageUrl
      titleImageBackgroundUrl
      ...LinkSection_pageSection
      ...OverviewSection_pageSection
      ...HomeFundIntroductionSection_pageSection
      ...HomeFundServiceSection_pageSection
      ...HomeFundInfoserviceSection_pageSection
    }
  }
`;
